import React, { useState, useEffect, useContext } from "react";
import { Card, Flex, InputItem, Popover, Button } from "antd-mobile";
import moment from "moment";
import _ from 'lodash';
import "moment/locale/zh-cn";

import DateRangeButton from "../components/DateRangeButton";
import BasicContext from "../BasicContext";
import { Empty, Loading, Radios } from "../components";
import Permission from '../components/Permission';

import { UrlSearch, renderCompanyCNameByCompanyId, formatBillUnit } from "../../../utils/utils";
import { AclKeys } from "../utils/permissions";
import { getPercentFormat, getSthousandsFormatNum } from "../utils/common";
import { getDateRange, renderDateRange, timeFormatType } from "../utils/timeFormat";
import { getSmsType, setSmsType } from "../../localStorage";
import * as Api from "../../../api/usms";
import { salespersonAndManager } from "../../../utils/const"

import "../index.css";

const Item = Popover.Item;

const CompanyType = { common: "直客", channel: "渠道客户" };
const defaultCompanyType = "common";
const sendDateList = ["当日", "上周", "上月"];
const defaultRangeBtn = "当日";
const sendDefaultDateRange = getDateRange(defaultRangeBtn);
const SortKey = {
	TotalCount: "发送总数",
	BillCount: "计费条数",
	SuccessPercent: "成功率",
	ProductRevenue: "产品收入(美元)",
	Profits: "利润(美元)",
	ProfitPercent: "利润率"
};
export default function SendStats(props) {
	moment.locale("zh-cn");

	const smsType = getSmsType();

	// 是否客户经理专用链接
	const ifManager = window.location.pathname.indexOf("/usms/manager/") > -1;
	const context = useContext(BasicContext);
	const customerList = context.customers;
	const userInfo = context.userInfo;
	const salespersonList = context.salespersonList;

	const [sendDateRange, setSendDateRange] = useState(sendDefaultDateRange);
	const [urlDateRange, setUrlDateRange] = useState();
	const [sortKey, setSortKey] = useState("TotalCount");
	const [sortUp, setSortUp] = useState(false);
	const [companyInput, setCompanyInput] = useState();
	const [customers, setCustomers] = useState(defaultCompanyType);
	const [selectProductVisible, setSelectProductVisible] = useState(false);

	// 统计
	const [list, setList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [originList, setOriginList] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		initData();	
	}, []);

	const initData = () => {
		// 企业微信推送只能带一个参数，处理一下时间范围
		const time = UrlSearch("time");
		const times = time && time.split("-");
		if (times && times.length === 2) {
			const start_time = Number(times[0]);
			const end_time = Number(times[1]);
			const dates = [moment(start_time * 1000), moment(end_time * 1000)];
			setSendDateRange(dates);
			setUrlDateRange(dates);
			getList(dates, customers);
		} else {
			getList(sendDefaultDateRange, customers);
		}
	};

	// 聚合Account统计信息
	const getAccountInfo = (list) => {
		return list.map((item) => {
		  if (!item.AccountStatistics || !Array.isArray(item.AccountStatistics) || item.AccountStatistics.length === 0) {
			return item;
		  }
	
		  const AccountStatistics = _.cloneDeep(item.AccountStatistics);
		  const results = AccountStatistics.reduce((accumulator, currentItem) => {
			const exists = accumulator.find(
			  (item) =>
				item.AccountId === currentItem.AccountId &&
				item.BrevityCode === currentItem.BrevityCode &&
				item.Purpose === currentItem.Purpose
			);
	
			if (exists) {
			  // 如果已存在，累加值
			  exists.TotalCount += +currentItem.TotalCount;
			  exists.AccountBillCount += +currentItem.AccountBillCount;
			  exists.CompanyRevenue += +currentItem.CompanyRevenue;
			  exists.ProductRevenue += +currentItem.ProductRevenue;
			  exists.SuccessCount += +currentItem.SuccessCount;
			  exists.Profits += +currentItem.Profits;
			} else {
			  // 如果不存在，将当前item添加到累积器中
			  accumulator.push(currentItem);
			}
	
			return accumulator;
		  }, []);
	
		  // 遍历计算成功率和利润率
		  results.forEach((item) => {
			item.SuccessPercent = ((item.SuccessCount / item.TotalCount) * 100).toFixed(1);
			item.ProfitPercent = ((item.Profits / item.CompanyRevenue) * 100).toFixed(1);
		  });
	
		  item.AccountAccumulateStatistics = results;
	
		  return item;
		});
	  };

	const getList = (dates, customers) => {
		setLoading(true);
		setErrorMessage("");
		const params = {}
		if (customers === defaultCompanyType) {
			// 直客
		    params.NoIndustryTagIds = [Number(process.env.REACT_APP_CHANNEL_CUSTOMER_ITID)];
		  } else {
		    params.IndustryTagIds = [Number(process.env.REACT_APP_CHANNEL_CUSTOMER_ITID)];
		}
		params.GroupCondition =  ["BrevityCode", "Purpose"];
		if(salespersonList.find(item => item.Email === userInfo.email) && !salespersonAndManager.includes(userInfo.email)){
			params.SalespersonEmail = [userInfo.email] || [];
		}
		const data = {
			StartTime: moment(dates[0])
				.startOf("day")
				.unix(),
			EndTime: moment(dates[1])
				.endOf("day")
				.unix(),
			...params
		};
		Api.GetCustomerStatistics(data)
			.then(res => {
				setList(getAccountInfo(res));
				setOriginList(res);
				setErrorMessage('')
				setLoading(false);
			})
			.catch(e => {
				setLoading(false);
				setList([])
				setErrorMessage(e.message || "获取数据失败");
			});
	}

	const onDateChange = dates => {
		setSendDateRange(dates);
		getList(dates, customers);
	};

	const onSortChange = key => {
		let sort = sortUp;
		if (sortKey === key) {
			sort = !sortUp;
			setSortUp(!sortUp);
		}
		setSortKey(key);
		const sortList = [...list];
		if (key === "SuccessPercent") {
			sortList.sort((a, b) => {
				if (sort) {
					return a.SuccessCount / a.TotalCount - b.SuccessCount / b.TotalCount;
				}
				return b.SuccessCount / b.TotalCount - a.SuccessCount / a.TotalCount;
			});
		} else {
			sortList.sort((a, b) => {
				if (sort) {
					return a[key] - b[key];
				}
				return b[key] - a[key];
			});
		}
		setList(sortList);
	};

	// 客户类型
	const onCustomerChange = value => {
		setCustomers(value);
		getList(sendDateRange, value)
	};

	const onCompanyChange = value => {
		setCompanyInput(value);
		const companyId = Number(value);
		if (value === "") {
			setList(originList);
		} else if (isNaN(companyId)) {
			const filterList = originList.filter(item => item.CompanyName.indexOf(value) > -1);
			setList(filterList);
		} else {
			const filterList = originList.filter(item => item.CompanyId === companyId);
			setList(filterList);
		}
	};

	const getAlarmPercent = (record, type, percent = 80) => {
		const render = getPercentFormat(record.SuccessCount, record.TotalCount);
		if ((record.SuccessCount / record.TotalCount) * 100 < percent && type === "SuccessPercent") {
			return <span style={{ color: "#f44336" }}>{render}</span>;
		}
		return <span style={{ color: "#4cd964" }}>{render}</span>;
	};

	const getProfitPercent = (record, percent = 80) => {
		const render = getPercentFormat(record.Profits, record.CompanyRevenue);
		if ((record.SuccessCount / record.TotalCount) * 100 < percent) {
			return <span style={{ color: "#f44336" }}>{render}</span>;
		}
		return <span style={{ color: "#4cd964" }}>{render}</span>;
	};

	const renderList = () => {
		if (list.length === 0) {
			return <Empty />;
		}

		const getDetailUrl = item =>
			`/usms/manager/statisticdetail?company_id=${item.CompanyId}&start_time=${moment(sendDateRange[0])
				.startOf("day")
				.unix()}&end_time=${moment(sendDateRange[1])
				.endOf("day")
				.unix()}`;
		const getPackageUrl = item => {
			if (ifManager)
				return `/usms/manager/statisticpackage?company_id=${item.CompanyId}&company_name=${item.CompanyName}`;
			else return `/usms/statisticpackage?company_id=${item.CompanyId}&company_name=${item.CompanyName}`;
		};

		return list.map((item, index) => (
			<Card full style={{ marginBottom: "8px" }} key={index}>
				<Card.Header
					title={`${renderCompanyCNameByCompanyId(item.CompanyId, customerList)}`}
					onClick={() => (window.location.href = getDetailUrl(item))}
				/>
				<Card.Body>
					<div
						style={{ borderBottom: "1px solid #E9E9E9" }}
						onClick={() => (window.location.href = getDetailUrl(item))}
					>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>发送总数：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(item.TotalCount)}
								</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>计费条数：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(item.BillCount)}
								</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>成功率：</span>
								<span style={{ fontWeight: "bold" }}>{getAlarmPercent(item, "SuccessPercent")}</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>利润率：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>{getProfitPercent(item)}</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>产品收入(美元)：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(formatBillUnit(item.ProductRevenue))}
								</span>
							</Flex.Item>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>利润(美元)：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>
									{getSthousandsFormatNum(formatBillUnit(item.Profits))}
								</span>
							</Flex.Item>
						</Flex>
						<Flex>
							<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
								<span>销售人员：</span>
								<span style={{ fontWeight: "bold", color: "#3498DB" }}>{item.SalespersonName}</span>
							</Flex.Item>
						</Flex>
					</div>
					{/* 预付费展示 */}
					{(item.Organizations || []).some(org => org.PaidType === 0) ? (
						<div style={{ borderBottom: "1px solid #E9E9E9", marginTop: 8, paddingBottom: 5 }}>
							<Flex>
								<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
									<span>国内短信余量：</span>
									<span style={{ fontWeight: "bold", color: "#3498DB" }}>
										{getSthousandsFormatNum(item.DomesticBalancePkgQuantity)}
									</span>
								</Flex.Item>
								<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
									<span>国外短信余量：</span>
									<span style={{ fontWeight: "bold", color: "#3498DB" }}>
										{getSthousandsFormatNum(item.ForeignBalancePkgQuantity)}
									</span>
								</Flex.Item>
							</Flex>
							<Flex>
								<Flex.Item style={{ fontSize: "13px", padding: "1px" }}>
									<span
										style={{ color: "#3498DB" }}
										onClick={() => (window.location.href = getPackageUrl(item))}
									>
										查看预付费套餐包
									</span>
								</Flex.Item>
							</Flex>
						</div>
					) : null}
				</Card.Body>
			</Card>
		));
	};

	const renderHeader = title => (
		<div style={{ display: "flex", justifyContent: "space-between" }}>
			<h3>{title}</h3>
			<Popover
				mask
				overlayStyle={{ color: "currentColor" }}
				visible={selectProductVisible}
				overlay={[
					<Item key="Text" value="Text" disabled={smsType === "Text"}>
						文本短信USMS
					</Item>,
					<Item key="Video" value="Video" disabled={smsType === "Video"} style={{ whiteSpace: "nowrap" }}>
						视频短信ISMS
					</Item>
				]}
				align={{
					overflow: { adjustY: 0, adjustX: 0 },
					offset: [-10, 0]
				}}
				onVisibleChange={visible => setSelectProductVisible(visible)}
				onSelect={value => {
					setSmsType(value.key);
				}}
			>
				<Button type="primary" size="small" disabled style={{ fontSize: 12, width: 80, flexShrink: 0 }}>
					切换产品
				</Button>
			</Popover>
		</div>
	);

	return (
		<div className="container">
			<Permission aclKey={AclKeys.SalesBoard}>
				{urlDateRange ? (
					<>
						{renderHeader(
							`${renderDateRange(urlDateRange, timeFormatType.date_xg)} ${
								smsType === "Text" ? "USMS" : "ISMS"
							} 运营数据：`
						)}
					</>
				) : (
					<>
						{renderHeader(`${smsType === "Text" ? "USMS" : "ISMS"} 运营数据：`)}
						<DateRangeButton
							dateList={sendDateList}
							value={sendDateRange}
							style={{ margin: "10px 0" }}
							size="small"
							onChange={dates => onDateChange(dates)}
							defaultRangeBtn={defaultRangeBtn}
						/>
					</>
				)}
				<div style={{ marginBottom: "10px" }}>
					<Radios
						value={sortKey}
						onChange={value => onSortChange(value)}
						type="ghost"
						activeType="ghost"
						options={Object.keys(SortKey).map(item => ({
							label: SortKey[item] + (sortKey === item ? (sortUp ? "↑" : "↓") : ""),
							value: item
						}))}
					/>
				</div>

				<div style={{ marginBottom: "10px" }}>
					<Radios
						value={customers}
						onChange={value => onCustomerChange(value)}
						activeType="ghost"
						options={Object.keys(CompanyType).map(item => ({
							label: CompanyType[item],
							value: item
						}))}
					/>
				</div>

				<div style={{ marginBottom: "10px" }}>
					<InputItem
						size="small"
						placeholder="搜索公司ID或公司名称"
						value={companyInput}
						onChange={onCompanyChange}
					>
						搜索
					</InputItem>
				</div>
				<Loading loading={loading} error={errorMessage}>
					{renderList()}
				</Loading>
			</Permission>
		</div>
	);
}
